import { Component } from '@angular/core';
import * as screenfull from 'screenfull';
import { GlobalService } from '../../globals/globals';
import { HttpService } from '../../globals/http';
import { StorageService } from '../../globals/storage';


@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {
  StorageService: any;
  hash: string;
  user: any;
  itens = [];
  mostra: any = false;
  mostrarFoto : boolean = false;
  constructor(
    private GlobalService: GlobalService,
    private httpService: HttpService,
    private storageSessionService: StorageService

  ) {
    this.hash = this.storageSessionService.getItem('token');
  }

  ngOnInit() {
    this.getItens().then(res => {

      this.mostra = true;
    }, error => {
    })
  }


  fullscreen() {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }

  /************
  GET
  *************/
  getItens() {

    return (
      this.httpService.JSON_GET(`/usuarios/dados/${this.hash}`, false, true)
        .then(
          res => {
   
            this.user = res.json()[0];
            return Promise.resolve(this.itens = res.json());
          },
          error => {
            this.mostrarFoto=true;
          }
        )
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/app-header/app-header.component.ts